export default "__VITE_ASSET__Du$vk9AE__"